// extracted by mini-css-extract-plugin
export var aiStarIcon = "_as-4";
export var closeButton = "_as-6";
export var dismissButton = "_as-3";
export var editImageWithAiContainer = "_as-8";
export var imageUploadWrapper = "_as-7";
export var misspelledWord = "_as-5";
export var spellCheckContainer = "_as-2";
export var spin = "_as-1";
export var spinning = "_as-0";